import { alpha, useTheme } from "@mui/material";
import shortid from "shortid";
import { Chip, Divider, Grid } from "../../../../components";

const ListStatusCustom = ({
  selectedStatus,
  setSelectedStatus,
  listaStatus,
  handleChangeStatus,
  filtrosAvancados,
  setFiltrosAvancados,
}) => {
  const theme = useTheme();

  const renderLabel = (status) => {
    if (status.status) {
      const textoMinusculo = status.status.toLowerCase();
      return textoMinusculo.charAt(0).toUpperCase() + textoMinusculo.slice(1);
    } else {
      return status.label;
    }
  };

  const validateStatus = (status) => {
    const texto = status.nome || status.status;
    return selectedStatus.find((item) => item.nome === texto);
  };

  const handleClick = (status) => {
    const texto = status.nome || status.status;
    let filtrosTemp = filtrosAvancados;
    if (texto !== "FECHADO" && filtrosAvancados?.hasPesquisas) return;
    if (texto === "FECHADO" && filtrosAvancados?.hasPesquisas) {
      delete filtrosTemp.hasPesquisas;
      setFiltrosAvancados(filtrosTemp);
    }

    const newStatus = validateStatus(status)
      ? selectedStatus.filter((item) => item.nome !== texto)
      : [...selectedStatus, { id: status.id, nome: texto }];

    setSelectedStatus(newStatus);
    handleChangeStatus(newStatus, filtrosTemp);
  };

  const handleChangePesquisas = () => {
    const filtrosTemp = {
      ...filtrosAvancados,
      hasPesquisas: !filtrosAvancados?.hasPesquisas,
    };
    const status = selectedStatus.filter((item) => item.nome === "FECHADO");
    setSelectedStatus(status);
    setFiltrosAvancados(filtrosTemp);
    handleChangeStatus(status, filtrosTemp);
  };

  const renderHoverColor = (condition) => (condition ? "#fff" : "#000");

  return (
    <Grid container spacing={2}>
      {listaStatus.map((status) => {
        const isSelected = validateStatus(status);
        const backgroundColor = isSelected
          ? status.cor
          : alpha(status.cor, 0.08);

        const textColor = isSelected
          ? theme.palette.getContrastText(backgroundColor)
          : "#000";

        const textHoverColor = isSelected
          ? "#000"
          : theme.palette.getContrastText(backgroundColor);

        return (
          <Chip
            className="d-flex my-2 mx-2 p-1"
            key={shortid.generate()}
            icon={<i className="ph-fill ph-circle"></i>}
            label={renderLabel(status)}
            sx={{
              backgroundColor,
              color: textColor,
              "&:hover": {
                backgroundColor: isSelected
                  ? alpha(status.cor, 0.08)
                  : alpha(status.cor, 0.75),
                color: textHoverColor,
                transform: "scale(1.05)",
                transition: "all 0.4s ease-in-out",
              },
              ".MuiChip-icon": {
                color: isSelected ? "#fff" : status.cor,
              },
              "&:hover .MuiChip-icon": {
                color: isSelected ? status.cor : "#fff",
                transition: "all 0.4s ease-in-out",
              },
            }}
            onClick={() => handleClick(status)}
          />
        );
      })}
      {selectedStatus.find((item) => item.nome === "FECHADO") && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ my: 1.5, border: "1px solid grey" }}
          />
          <Chip
            className="d-flex my-2 mx-2 p-1"
            key={shortid.generate()}
            icon={<i className="ph-bold ph-smiley"></i>}
            label="Com Avaliação Realizada"
            sx={{
              backgroundColor: filtrosAvancados?.hasPesquisas
                ? "#164221"
                : alpha("#164221", 0.08),
              color: renderHoverColor(filtrosAvancados?.hasPesquisas),
              "&:hover": {
                backgroundColor: filtrosAvancados?.hasPesquisas
                  ? alpha("#164221", 0.08)
                  : alpha("#164221", 0.75),
                color: renderHoverColor(!filtrosAvancados?.hasPesquisas),
                transform: "scale(1.05)",
                transition: "all 0.2s ease-in-out",
              },
              ".MuiChip-icon": {
                color: renderHoverColor(filtrosAvancados?.hasPesquisas),
              },
              "&:hover .MuiChip-icon": {
                color: renderHoverColor(!filtrosAvancados?.hasPesquisas),
              },
            }}
            onClick={handleChangePesquisas}
          />
        </>
      )}
    </Grid>
  );
};

export default ListStatusCustom;
